<template>
  <div>
    <overpop2charts class="chart" :updateArgs="[true, true, true]" :options="chartOptions"></overpop2charts>
    <!--<p>{{ items }}</p>
    <div v-for="item in items" :key="item" class="item">
      {{ item.data_year }}:
      {{ item.sector }}
      {{ item.category_details }}
    </div>-->
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import drilldownInit from "highcharts/modules/drilldown";
import exportingInit from "highcharts/modules/exporting";
import stockInit from "highcharts/modules/stock";

import { EventBus } from "@/event-bus.js";

stockInit(Highcharts);
exportingInit(Highcharts);
drilldownInit(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ","
  }
});

export default {
  props: {
    partsdata: {
      type: Array
    }
  },

  components: {
    overpop2charts: Chart
  },

  created() {
    EventBus.$on("btn-clicked", data => {
      this.chartOptions.series[0].data = data.newData;
    });
  },

  data() {
    return {
      loading: true,
      errored: false,
      chartOptions: {
        chart: {
          type: "pie"
        },

        title: {
          text: "Top 5 Countries with Largest Emissions, 2020"
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
        },
        accessibility: {
          point: {
            valueSuffix: "%"
          }
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
              connectorColor: "silver"
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: "Emission",
            colorByPoint: true,
            data: [
              {
                name: "Other",
                y: 7487,
                sliced: true,
                selected: true
              },
              {
                name: "China",
                y: 2805
              },
              {
                name: "United States",
                y: 1353
              },
              {
                name: "Russia",
                y: 988
              },
              {
                name: "India",
                y: 797
              },
              {
                name: "Brazil",
                y: 600
              }
            ]
          }
        ]
      }
    };
  }
};
</script>
